import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  error: {
    id: 'studio.8DCbBc',
    defaultMessage: 'There was a problem cancelling your subscription.',
  },
  title: {
    id: 'studio.UWVETE',
    defaultMessage: 'Cancel subscription',
  },
  help: {
    id: 'studio.8+1M5S',
    defaultMessage: 'Please provide the reasoning for cancelling your subscription.',
  },
  cancellationReason: {
    id: 'studio.mMzjeW',
    defaultMessage: 'Cancellation reason',
  },
  cancelSubscription: {
    id: 'studio.UWVETE',
    defaultMessage: 'Cancel subscription',
  },
  keepSubscription: {
    id: 'studio.KiHDv6',
    defaultMessage: 'Keep subscription',
  },
});
